import { render } from "./About.vue?vue&type=template&id=6caa5d38"
const script = {}
script.render = render

export default script